import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getScoresBySport } from '../../axios-services';
import './scoresPage.css';

const ScoresPage = () => {

    const { leagueKey } = useParams();
    const [scoresList, setScoresList] = useState([]);


    const convertToDate = (dateTime) => {
        let date = new Date(dateTime).toLocaleDateString(undefined, {
            day: 'numeric',
            month: 'numeric'
        });
        return date
    }

    const convertToTime = (dateTime) => {
        let time = new Date(dateTime).toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });
        return time
    }


    useEffect(() => {
        const getScores = async () => {
            const scores = await getScoresBySport(leagueKey);
            setScoresList(scores);
        }
        getScores();
    }, [leagueKey])


    return (
            <div className='games-info'>
                {scoresList.map((game) => {
                    return (
                        <div key={game.id}>
                            <h4>{game.sport_title}</h4>
                            <div className='box-score'>
                                <div className='game-status'>
                                    {game.completed ?
                                        <>
                                            FINAL <br />
                                            {convertToDate(game.commence_time)}
                                        </>
                                        :
                                        <>
                                            {game.scores ?
                                            <>{ convertToDate(game.commence_time)}</>
                                            :
                                            <>
                                                {convertToDate(game.commence_time)} <br />
                                                {convertToTime(game.commence_time)}
                                            </>}
                                        </>
                                    }
                                </div>
                                <div className='teams'>
                                    <div>{game.away_team}</div>
                                    <div>{game.home_team}</div>
                                </div>
                                <div className='score'>
                                    <div>{game.scores ? game.scores[1].score : null}</div>
                                    <div>{game.scores ? game.scores[0].score : null}</div>
                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </div>

    )




}

export default ScoresPage;